/* eslint-disable react/no-unescaped-entities */
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { PROVIDERS } from 'constants/keys'
import { resolveAkamaiUrl, setSocialToken } from 'helpers/auth'

// Components
import Text from 'ui/Text'
import Row from 'ui/Row'
import Col from 'ui/Col'
import Modal from 'ui/Modal'
import Button from 'ui/Button'
import Loading from 'ui/Loading'
import Space from 'ui/Space'

export const PopupMergeAccount = ({
  title,
  message,
  description,
  existingProvider,
  newProvider,
  token,
  mergeTranditional,
  ...props
}) => {
  // State
  const [visible, setVisible] = useState(true)
  const [loading] = useState(false)

  const onClick = async () => {
    if (existingProvider === 'capture') {
      mergeTranditional(newProvider, token)
      setVisible(false)
      return
    }

    setSocialToken(token)

    // Call social login for existingProvider to get token
    const akamaiUrl = resolveAkamaiUrl(existingProvider, true)

    if (akamaiUrl) {
      window.open(akamaiUrl, '_self')
    }
  }

  const resolveIcon = (value) => {
    const provider = PROVIDERS.find((x) => x.provider === value)
    return provider && <provider.icon></provider.icon>
  }

  return (
    <Modal show={visible} style={{ textAlign: 'center' }} {...props}>
      <Loading spinning={loading}>
        <Text size={28} bold paddingBottom={30} color="#0c66c1">
          {title}
        </Text>

        <Text size={17} color="#0c66c1">
          {description}
        </Text>

        <Space style={{ padding: '20px 0' }}>
          {resolveIcon(existingProvider)} {resolveIcon(newProvider)}
        </Space>

        <Text size={17} color="#0c66c1" paddingBottom={15}>
          {message}
        </Text>

        <Row>
          <Col xs={{ span: 8, offset: 2, vcenter: true }}>
            <Button
              block
              style={{ backgroundColor: '#0c66c1', borderRadius: '3px' }}
              onClick={onClick}
            >
              LINK ACCOUNT
            </Button>
          </Col>
        </Row>
      </Loading>
    </Modal>
  )
}

PopupMergeAccount.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  existingProvider: PropTypes.string,
  newProvider: PropTypes.string,
  token: PropTypes.string,
  mergeTranditional: PropTypes.func,
}

PopupMergeAccount.defaultProps = {
  title: 'Please link your account',
  description:
    'The email address that you used to log in just now is already associated with a Globe Login account.',
  message:
    'Link this email address with your Globe account by clicking the Link Account button below to use it as your login next time.',
  existingProvider: '',
  newProvider: '',
  token: '',
  mergeTranditional: () => {},
}

export default PopupMergeAccount
